import {requests} from "../api/request";

export function getStatusName(status) {
    switch (status) {
        case 'NEW_BY_PATIENT':
            return 'Demandée par le patient';
        case 'NEW_BY_PRACTITIONER':
            return 'Demandée par le praticien';
        case 'CONFIRMED':
            return 'Acceptée';
        case 'CANCELLED_BY_PATIENT':
            return 'Annulée par le patient';
        case 'CANCELLED_BY_PRACTITIONER':
            return 'Annulée par le praticien';
        case 'TERMINATED':
            return 'Terminée en attente des fichiers';
        case 'CLOSED':
            return 'Fermée';
        default:
            return 'Statut inconnu';
    }
}
export function getStatusColor(status) {
    switch (status) {
        case 'NEW_BY_PATIENT':
        case 'NEW_BY_PRACTITIONER':
            return 'secondary';
        case 'TERMINATED':
        case 'CONFIRMED':
            return 'info';
        case 'CANCELLED_BY_PATIENT':
        case 'CANCELLED_BY_PRACTITIONER':
            return 'danger';
        case 'CLOSED':
            return 'success';
        default:
            return 'secondary';
    }
}

export function getChannels() {
    return {
        remote: 'Téléconsultation',
        medical_office: 'En cabinet',
        home: 'À domicile',
    }
}

export function getChannelName(channel) {
    return getChannels()[channel];
}

export function getCivilities() {
    return {
        m: 'M.',
        mme: 'Mme',
        dr: 'Dr.',
        pr: 'Pr.',
        dre: 'Dre.',
        pre: 'Pre.',
    }
}

export function getCivility(civility) {
    return getCivilities()[civility];
}

export const convertDateToDash = (date) => {
    if (date) {
        return date
            .split('/')
            .reverse()
            .join('-');
    }
    return null;
};



// WEBPACK FOOTER //
// ./src/utils/tools.js